import { useRecordContext } from 'react-admin';
import PropTypes from 'prop-types';
import Markdown from 'react-markdown';

export const MarkdownField = (props) => {
	const record = useRecordContext(props);
	const { source } = props;
	const markdown = record[source];
	return <Markdown>{markdown}</Markdown>;

};

MarkdownField.propTypes = {
	source: PropTypes.string
};

export default MarkdownField;